import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "components/generales/Navbar";
import Boton from "components/boton/Boton";
import axios from "axios";
import FormularioGastos from "components/gastos/FormularioGastos";

const EditarGasto = () => {
  const [gasto, setGasto] = useState({});
  const [cargando, setCargando] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  console.log(id);
  useEffect(() => {
    const obtenerGastoApi = async () => {
      try {
        const { data } = await axios.get(
          `https://mymoney5.herokuapp.com/gastos/${id}`
        );
        setGasto(data);
      } catch (error) {}
      setCargando(false);
    };
    obtenerGastoApi();
  }, []);

  return (
    <>
      <Navbar />
      <section>
        <div className="imagenContenedor imagenGastos"></div>
        <div className="contenidoContenedor">
          <div className="formularioContenedor">
            <h2>Editar Gasto</h2>
            {gasto?.descripcion ? (
              <FormularioGastos gasto={gasto} cargando={cargando} />
            ) : (
              <p className="formulario-error">Gasto no encontrado</p>
            )}

            <Boton
              type="button"
              buttonStyle="botonPrimarioSolido"
              onClick={() => navigate(`/gastos/`)}
            >
              Regresar
            </Boton>
          </div>
        </div>
      </section>
    </>
  );
};

export default EditarGasto;
